import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=560eee28&scoped=true"
import script from "./mainApp.vue?vue&type=script&lang=js"
export * from "./mainApp.vue?vue&type=script&lang=js"
import style0 from "./mainApp.vue?vue&type=style&index=0&id=560eee28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560eee28",
  null
  
)

export default component.exports